/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { VerifyCode } from './components/VerifyCode'



export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundSize: 'cover',
        backgroundImage: `url(${toAbsoluteUrl('/media/brandimages/mip-back.jpg')})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}

        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className=' bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' component={Registration} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/verify-code' component={VerifyCode} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex  align-items-center fw-bold fs-6'>
          <a href='#' className='text-white text-hover-primary px-2'>
            درباره ما
          </a>

          <a href='#' className='text-white text-hover-primary px-2'>
            تماس با ما
          </a>

          <a href='#' className='text-white text-hover-primary px-2'>
             پشتیبانی
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}
